export default {
  step_0: {
    imei: undefined,
    plate: undefined
  },
  step_1: {
    user: {
      firstname: undefined,
      lastname: undefined,
      ragsoc: undefined,
      birthday: undefined,
      address: undefined,
      number: undefined,
      city: undefined,
      postcode: undefined,
      province: undefined,
      country: undefined,
      taxcode: undefined,
      email: undefined,
      mobile: undefined
    },
    car: {
      registrationOdometer: 0,
      vehicleType: 'car',
      alimentation: undefined,
      casenumber: undefined,
      displacement: undefined,
      matriculationYear: undefined,
      plate: undefined,
      make: {
        codiceMarca: undefined,
        descrizione: undefined
      },
      model: {
        codiceModello: undefined,
        descrizione: undefined
      },
      type: {
        codiceAllestimento: undefined,
        codiceInfocarAM: undefined,
        descrizione: undefined
      }
    }
  },
  step_2: {
    installed: false
  },
  step_3: {
    product: {
      id: undefined,
      serviceId: undefined,
      paymentType: undefined,
      paymentExceptionForActivation: undefined,
      startDate: undefined,
      signaturePlace: undefined,
      signatureDate: undefined,
      signatureMethod: undefined
    },
    maintenances: {
      servicing: {
        checked: false,
        model: undefined,
        variant: undefined
      },
      customServices: {
        checked: false,
        services: []
      }
    },
    personalData: {
      read: undefined,
      agreementProfiling: undefined,
      agreementMarketing: undefined,
      agreementThirdParties: undefined
    }
  }
};



// WEBPACK FOOTER //
// ./src/stores/registrationStore/formDefault.json.js